import { FirebaseList } from '../firebase';
import * as roomBrowseActions from './actions';
import { RoomBrowseEntry } from './room-browse-entry';


export const roomBrowseList = new FirebaseList({
  onAdd: roomBrowseActions.createRoomSuccess,
  onChange: roomBrowseActions.updateRoomSuccess,
  onLoad: roomBrowseActions.loadRoomsSuccess,
  onRemove: roomBrowseActions.deleteRoomSuccess
}, RoomBrowseEntry);


// WEBPACK FOOTER //
// ./src/core/room-browse/room-browse-list.js